module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAiklEQVR4AWOgD9CuZ9CqZ1Ct1gucphc0jUG5ikGzDih4TlANDSE0sBk0cRk0TVt+Oqtxk6Jzn6hNJwEN+kHT1u25zqBQwaBUtXDTBXXvSQQ0MOk0sOg1MihWSjv3Clt3Ap1HQAMQARXZxc2zT5jPoFYD5BKlYdm2S96ZSxlUqglogHAw0TDVMCgBAMBlluAm8qMyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/WS.png
// module id = 1303
// module chunks = 0